import { BRANDS } from "@/lib/brands";
import WPMLogo from "@/components/WPMLogo";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[hsl(var(--ink))] text-[hsl(var(--bg))] pt-20 pb-10 relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.05] bg-noise pointer-events-none" />
      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <div className="bg-white rounded-md px-2 py-1.5">
                <WPMLogo size={28} />
              </div>
              <div>
                <div className="font-display font-semibold text-lg">Web Print Media</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/60">
                  {t("footer.tagline")}
                </div>
              </div>
            </div>
            <p className="mt-6 max-w-md text-white/70 text-[15px] leading-relaxed">{t("footer.intro")}</p>
            <div className="mt-7 flex flex-col gap-2 font-mono text-sm">
              <a href="tel:+41325100620" className="text-white/85 hover:text-[hsl(var(--accent))] transition-colors">
                +41 32 510 06 20
              </a>
              <a href="mailto:hello@webprintmedia.swiss" className="text-white/85 hover:text-[hsl(var(--accent))] transition-colors">
                hello@webprintmedia.swiss
              </a>
            </div>
            <div className="mt-8 flex items-center gap-3" data-testid="swiss-made-badge">
              <div className="bg-white rounded-md px-3 py-2 inline-flex items-center">
                <img src="/swiss-made-software.svg" alt="Swiss Made Software" className="h-7 w-auto" />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/45 mb-4">{t("footer.colStudio")}</div>
              <ul className="space-y-2.5 text-[14px]">
                <li><a href="#brands" className="hover:text-[hsl(var(--accent))]">{t("nav.brands")}</a></li>
                <li><a href="#services" className="hover:text-[hsl(var(--accent))]">{t("nav.services")}</a></li>
                <li><a href="#contact" className="hover:text-[hsl(var(--accent))]">{t("nav.contact")}</a></li>
              </ul>
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/45 mb-4">{t("footer.colFeatured")}</div>
              <ul className="space-y-2.5 text-[14px]">
                {BRANDS.slice(0, 6).map((b) => (
                  <li key={b.name}>
                    <a href={b.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:opacity-80" style={{ color: b.color }}>
                      <i className={`fa-solid ${b.icon} text-[11px]`} />
                      {b.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/45 mb-4">{t("footer.colMore")}</div>
              <ul className="space-y-2.5 text-[14px]">
                {BRANDS.slice(6).map((b) => (
                  <li key={b.name}>
                    <a href={b.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:opacity-80" style={{ color: b.color }}>
                      <i className={`fa-solid ${b.icon} text-[11px]`} />
                      {b.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between text-xs text-white/55 font-mono">
          <div>© {new Date().getFullYear()} Web &amp; Print Media Switzerland Sàrl · {t("footer.copyright")}</div>
          <div className="flex items-center gap-5">
            <a href="/imprint" data-testid="footer-imprint" className="hover:text-[hsl(var(--accent))] transition-colors">
              {t("footer.imprint")}
            </a>
            <div className="flex items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-[#22c55e] opacity-70 pulse-dot" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[#22c55e]" />
              </span>
              {t("footer.allOperational")}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
